import { render, staticRenderFns } from "./TemplateDashboardForm.vue?vue&type=template&id=19bcb044"
import script from "./TemplateDashboardForm.vue?vue&type=script&lang=js"
export * from "./TemplateDashboardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports